import CodebookValueNotFoundError from '../CodebookValueNotFoundError'
import { $t } from '../../composables/i18n'
import { StringUtils } from '../../utils/String'

export enum MealTypeId {
  NONE = 1,
  BREAKFAST = 2,
  LUNCH = 3,
  DINNER = 4,
  HALF_BOARD = 5,
  FULL_BOARD = 6,
  PACKAGE = 7,
  ALL_INCLUSIVE = 8,
  EARLY_DINNER = 9,
  HALF_BOARD_EARLY_DINNER = 10,
}

export class MealType {
  private constructor(
    public readonly id: MealTypeId,
    public readonly name: () => string,
  ) {}

  static readonly NONE = new MealType(MealTypeId.NONE, () => $t('without meals'))
  static readonly BREAKFAST = new MealType(MealTypeId.BREAKFAST, () => $t('breakfast'))
  static readonly LUNCH = new MealType(MealTypeId.LUNCH, () => $t('lunch'))
  static readonly DINNER = new MealType(MealTypeId.DINNER, () => $t('dinner'))
  static readonly HALF_BOARD = new MealType(MealTypeId.HALF_BOARD, () => $t('half-board'))
  static readonly FULL_BOARD = new MealType(MealTypeId.FULL_BOARD, () => $t('full-board'))
  static readonly PACKAGE = new MealType(MealTypeId.PACKAGE, () => $t('package'))
  static readonly ALL_INCLUSIVE = new MealType(MealTypeId.ALL_INCLUSIVE, () => $t('all-inclusive'))
  static readonly EARLY_DINNER = new MealType(MealTypeId.EARLY_DINNER, () => $t('snack'))
  static readonly HALF_BOARD_EARLY_DINNER = new MealType(MealTypeId.HALF_BOARD_EARLY_DINNER, () =>
    $t('HB with an early dinner'),
  )

  public nameCapitalize(): string {
    return StringUtils.capitalize(this.name())
  }

  static getById = (id: MealTypeId): MealType => {
    const value = MealType.all().find((item) => item.id === id)

    if (value === undefined) {
      throw new CodebookValueNotFoundError(MealType.name, id)
    }

    return value
  }

  static all = (): MealType[] => {
    return [
      MealType.NONE,
      MealType.BREAKFAST,
      MealType.LUNCH,
      MealType.DINNER,
      MealType.HALF_BOARD,
      MealType.FULL_BOARD,
      MealType.PACKAGE,
      MealType.ALL_INCLUSIVE,
      MealType.EARLY_DINNER,
      MealType.HALF_BOARD_EARLY_DINNER,
    ]
  }
}
